import { Paths } from 'shared/routes';

import { Progress } from './progress';
// import { Roadmap } from './roadmap';
import { Summary } from './summary';
import { Tasks } from './tasks';

export const GoalDetailRoutes = [
  {
    path: Paths.GoalDetail,
    element: <Summary />,
  },
  {
    path: Paths.GoalDetailProgress,
    element: <Progress />,
  },
  // {
  //   path: Paths.GoalDetailRoadmap,
  //   element: <Roadmap />,
  // },
  {
    path: Paths.GoalDetailTasks,
    element: <Tasks />,
  },
];
